// extracted by mini-css-extract-plugin
export default {"modalStyles":"mapModal_modalStyles__7pjvI"};